<template>
    <div class="page-content">
        <h4 class="mt-n2 mb-4">
            Pending Logs
            <span class="top_heading_CreatePartner_btn d-block d-flex align-items-center float-end">
                <div class="Group_top_three_dot">
                    <div class="dropdown">
                        <button class="btn p-0 Group_top_three_dot_dropdown" type="button">
                            <img src="../../../public/dashboard-assets/images/M2/date-icon.png" @click="opencal"
                                data-bs-toggle="tooltip" data-bs-placement="top" title="Filter by Date" />
                            <span class="cal-alert translate-middle" v-if="fromDate">
                                <span class="visually-hidden"></span>
                            </span>
                            <input type="text" name="daterange" hidden id="calendar_icon" class="fade" />
                        </button>
                    </div>
                </div>
            </span>
        </h4>
        <div class="table-responsive card p-2" style="width: 100%; max-height: 500px;" v-if="logs.length > 0">
            <table class="table">
                <thead>
                    <tr>
                        <th>Client ID</th>
                        <th>Client Name</th>
                        <th>Test ID</th>
                        <th>Test Name</th>
                        <th>Counts</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="log in paginatedLogs" :key="log.client_Id">
                        <td>{{ log.clientId }}</td>
                        <td>{{ log.clientName }}</td>
                        <td>{{ log.testId }}</td>
                        <td>{{ log.testName }}</td>
                        <td>{{ log.counts }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="text-center" v-else>
            <img src="../../../public/dashboard-assets/images/M2/empty_record.png" style="width: 20%" class="my-5" />
            <h3 class="ms-5 mt-2">No Details Found</h3>
        </div>
        <!-- pagination -->
        <div class=" my-2" v-if="logs.length > 0">
            <paginate v-model="currentPage" :page-count="Page_count" :margin-pages="1" :page-range="1"
                :click-handler="clickCallback" :prev-text="'< Prev'" :next-text="'Next >'"
                :container-class="'pagination'" :page-class="'page-item'">
            </paginate>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import Paginate from "vuejs-paginate-next";

export default {
    name: "PendingLogs",
    components: {
        paginate: Paginate,
    },
    data() {
        return {
            logs: [],
            fromDate: moment().subtract(1, 'months').startOf('month').format("YYYY-MM-DD 00:00:00"),
            toDate: moment().subtract(1, 'months').endOf('month').format("YYYY-MM-DD 23:59:59"),

            //local pagination
            currentPage: 1,
            limit: 7,
            Page_count: 0,
        }
    },
    methods: {
        ...mapActions(["GetPendingLogsByDate"]),
        opencal() {
            document.getElementById("calendar_icon").click();
        },
        async fetchLogs() {

            const toDateMoment = moment(this.toDate, "YYYY-MM-DD HH:mm:ss"); // Convert string back to moment
            const nextDay = toDateMoment.clone().add(1,'day').format("YYYY-MM-DD HH:mm:ss");
            //console.log(nextDay);   // e.g. "2025-05-08 14:30:00"
            // const nextMonth = toDateMoment.add(1, 'month').startOf('month').format("YYYY-MM-DD 00:00:00");

            const response = await this.GetPendingLogsByDate({
                startExamEndTime: this.fromDate,
                endExamEndTime: this.toDate,
                createdDate: nextDay
            });

            this.logs = response.object.data;
            // Calculate total pages
            this.Page_count = Math.ceil(this.logs.length / this.limit);
        }

    },
    async mounted() {
        window.$('input[name="daterange"]').daterangepicker(
            {
                maxDate: new Date(),
                locale: { cancelLabel: "Clear" },
                opens: "center",
            },
            (start, end) => {
                if (start && end) {
                    this.fromDate = start.format("YYYY-MM-DD 00:00:00");
                    this.toDate = end.format("YYYY-MM-DD 23:59:59");
                }
            }
        );
        window
            .$('input[name="daterange"]')
            .on("cancel.daterangepicker", (ev, picker) => {
                picker.startDate._d = new Date();
                picker.endDate._d = new Date();
                this.fromDate = this.dateformat(
                    new Date(new Date().setMonth(new Date().getMonth() - 6))
                ),
                    this.toDate = this.todateformat(new Date(new Date())),
                    window.$('input[name="daterange"]').val("");
            });
        window
            .$('input[name="daterange"]')
            .on("apply.daterangepicker", async (ev, picker) => {
                var x = moment(String(picker.startDate._d)).format("YYYY-MM-DD 00:00:00");
                var y = moment(String(picker.endDate._d)).format("YYYY-MM-DD 23:59:59");
                var start = moment(String(picker.startDate._d)).format("YYYY-MM-DD 00:00:00")
                var end = moment(String(picker.endDate._d)).format("YYYY-MM-DD 23:59:59")
                if (
                    Math.ceil(
                        Math.abs(new Date(start) - new Date(end)) /
                        (1000 * 60 * 60 * 24)
                    ) <= 180
                ) {
                    this.fromDate = x;
                    this.toDate = y;

                    await this.fetchLogs();
                } else {
                    return this.ShowWarningMessage("Please select range within 6 months");
                }

            });
        this.fetchLogs();
    },
    computed: {
        paginatedLogs() {
            const start = (this.currentPage - 1) * this.limit;
            const end = start + this.limit;
            return this.logs.slice(start, end);
        }
    }

}
</script>
